import { GoogleAuthProvider, UserCredential, getAuth, signInWithPopup } from "firebase/auth";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import AuthApi from "../../api/AuthApi";
import firebaseConfig from "../../config/firebase.config";
import { EToastvariant, ILoginResponse } from "../../config/interfaces";
import { useAppDispatch } from "../../redux/Store";
import { setLoggedInUser } from "../../redux/slice/LoggedInUserSlice";
import { showToastMsg } from "../../redux/slice/ToastMsgSlice";
import { StorageService, UtilService } from "../../services";
import SvgImage from "../SvgImage";

type Props = {
  buttonTitle: string;
  route?: string;
};

const GoogleSignInBtn: React.FC<Props> = (props: Props) => {
  const { buttonTitle, route } = props;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const AUTH = getAuth(firebaseConfig);

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result: UserCredential = await signInWithPopup(AUTH, provider);
      if (result?.user) {
        const idToken = await result?.user?.getIdToken();
        const authApi = AuthApi.getInstance();
        const resp = await authApi.loginWithGoogle({ firebaseIdToken: idToken });

        dispatch(
          showToastMsg({
            isVisible: true,
            title: "Success",
            message: route ? "Registered successfully" : "Logged in successfully",
            variant: EToastvariant.Success
          })
        );
        handleAuth(resp, route);
      }
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    }
  };

  const handleAuth = async (_data: ILoginResponse, route?: string) => {
    await StorageService.setTermsAccepted(_data.user.termsAcceptedAt);
    await StorageService.setApiToken(_data.authToken);
    await StorageService.removePrePostVerifyData();

    dispatch(setLoggedInUser(_data.user));
    const isPublicPlanUUID = await StorageService.getMarketPlansUrl();
    if (isPublicPlanUUID) {
      navigate("/itr-filings", { replace: true });
    } else if (route) {
      navigate(route, { replace: true });
    } else {
      navigate("/home", { replace: true });
    }
  };

  return (
    <div className="social-btn-wrap">
      <Button
        variant="greyLight"
        type="button"
        size="lg"
        className="w-100 "
        onClick={handleGoogleLogin}
      >
        <SvgImage imgId="google-icon" />
        {buttonTitle}
      </Button>
    </div>
  );
};

export default GoogleSignInBtn;
